export default __webpack_public_path__ + "static/media/logo.4806dd53.png";